import { appStorage } from "@/lib/stores/tab-storage";

/**
 * The four-step onboarding's persisted progress (`onboarding-state:<user>`,
 * and the un-namespaced key before it), which nothing reads since the first
 * run replaced it with one screen (task 512). Removed at boot so it does not
 * sit in every browser that ever onboarded.
 */
const PREFIX = "onboarding-state";

export function forgetOnboardingProgress(): void {
  try {
    const storage = appStorage();
    const stale: string[] = [];
    for (let i = 0; i < storage.length; i++) {
      const key = storage.key(i);
      if (key === PREFIX || key?.startsWith(`${PREFIX}:`)) stale.push(key);
    }
    for (const key of stale) storage.removeItem(key);
  } catch {
    // Storage blocked: there is nothing it could have kept either.
  }
}
